import React from "react";
import "./Footer.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import sparkLogo from "./images/spark-logo.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer">
      <div className=" container">
        <div className="location">
          <div className="email">
            <i class="fa-solid fa-envelope"></i>
            <h3 className=" text-uppercase">Email Us</h3>
            <Link>spark@gmail.com</Link>
          </div>
          <div className="address ">
            {" "}
            <i class="fa-solid fa-location-dot"></i>{" "}
            <h3 className=" text-uppercase">visit Us</h3>
            <Link>
              Sheikh Zayed <br /> 8th District <br />
              1st Neighborhood,
              <br /> Building 42
            </Link>
          </div>

          <div className=" phone">
            {" "}
            <i class="fa-solid fa-phone-volume"></i>{" "}
            <h3 className=" text-uppercase">contact Us</h3>
            <Link>01123846472</Link>
          </div>
        </div>

        <div className="content">
          <div className="animation ">
            <DotLottieReact
              src="https://lottie.host/49995a2b-7dd1-444a-b043-21f40573583b/y8k78SmXmq.lottie"
              loop
              autoplay
              className="advertising-animation"
            />
          </div>
          <div className="icons-social">
            <Link>
              {" "}
              <i class="fa-brands fa-whatsapp">
                <span>whatsapp</span>
              </i>{" "}
            </Link>

            <Link>
              {" "}
              <i class="fa-brands fa-instagram">
                <span>instagram</span>
              </i>{" "}
            </Link>

            <Link>
              {" "}
              <i class="fa-brands fa-facebook-f">
                <span> facebook</span>
              </i>
            </Link>
          </div>
          <div className="img-footer">
            <img src={sparkLogo} alt="" />
          </div>
        </div>

        <div className="finish">
          <p> <span>©</span> All rights reserved to Spark Company.</p>
        </div>
      </div>
    </div>
  );
}
